import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';

var useScroll = function useScroll() {
  var _useState = useState({
    previous: {
      x: null,
      y: null
    },
    current: {
      x: null,
      y: null
    },
    direction: {
      x: null,
      y: null
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      scroll = _useState2[0],
      setScroll = _useState2[1];

  var handleScroll = function handleScroll() {
    return setScroll(function (scroll) {
      var current = {
        x: window.scrollX,
        y: window.scrollY
      };
      var previous = scroll.current.x != null ? scroll.current : current;
      var direction = {
        x: current.x > previous.x ? 'right' : 'left',
        y: current.y > previous.y ? 'down' : 'up'
      };
      return {
        current: current,
        previous: previous,
        direction: direction
      };
    });
  };

  useEffect(function () {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return function () {
      return window.removeEventListener('scroll', handleScroll, {
        passive: true
      });
    };
  }, []);
  return scroll;
};

export default useScroll;